'use strict';

const resetPassPage = '.js-crm-reset-password';
const gtm = require('./modules/google').tagManager;
const login = require('./login');

function closeResetPasswordToaster() {
    if ($('.js-reset-password-confirmation').hasClass('open')) {
        $('.js-modal-overlay').addClass('flyin-component');
    }

    $('.js-reset-password-close').on('click', function () {
        $('.js-reset-password-confirmation').removeClass('open');
        $('.js-modal-overlay').removeClass('flyin-component');
    });

    $('.js-modal-overlay').on('click', function () {
        $('.js-reset-password-confirmation').removeClass('open');
        $('.js-modal-overlay').removeClass('flyin-component');
    });

    $('.js-continue-password-reset').on('click', function () {
        $('.js-reset-password-confirmation').removeClass('open');
        $('.js-modal-overlay').removeClass('flyin-component');
    });
}

function sendMeMyCardByEmail() {
    $('.js-onboarding-email-card').on('click', function (e) {
        sendCustomerID(e.target.value);
    });
}

function sendCustomerID(customerID) {
    $.ajax({
        url: Urls.sendMemberCardByEmail,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
            contactId: customerID
        }),
        success: function(response) {
            if (response.data.toLowerCase() === 'ok') {
                const toasterConteiner = $('.js-reset-password-confirmation.page-loaded');
                const toasterConteinerText = toasterConteiner.find('span.text-container');
                toasterConteinerText.text(response.confirmationMessage);
                toasterConteiner.addClass('open');
            }
        }
    });
}

function pushAnalyticsDataRegistrationForm() {
    const registrationForm = $('#RegistrationSmsForm');
    if (registrationForm.length > 0) {
        registrationForm.submit(function () {
            gtm.pushDataLayerEvent({
                event: 'sign_up',
                emailAddress: registrationForm.data('emailaddress')
            });
        });
    }
}

function pushAnalyticsDataLoginForm() {
    const loginForm = $('.js-crm-in-store-login');
    if (loginForm.length > 0) {
        loginForm.submit(function () {
            gtm.pushDataLayerEvent({
                event: 'login',
                emailAddress: loginForm.data('emailaddress')
            });
        });
    }
}

// CRM 2.3 registration page - show phone number input field when checkbox is checked
function showPhoneNumberOnRegistrationForm() {
    const registrationForm = $('.crm-in-store-register');
    if (registrationForm.length > 0) {
        const addToLoyaltySmsList = $('input[name="dwfrm_profile_customer_loyalty_addtoloyaltysmslist"]');

        if (addToLoyaltySmsList.length > 0) {
            const smsPhone = $('input[name="dwfrm_profile_customer_loyalty_smsPhoneOnboarding"]');
            const smsPhoneFormRow = smsPhone.closest('.form-row');

            smsPhoneFormRow.hide();
            addToLoyaltySmsList.on('click', function () {
                if ($(this).prop('checked')) {
                    smsPhone.removeAttr('disabled');
                    smsPhoneFormRow.addClass('form-number-visible');
                    smsPhoneFormRow.fadeIn();
                } else {
                    smsPhoneFormRow.removeClass('form-number-visible');
                    smsPhoneFormRow.hide();
                    smsPhone.attr('disabled', true);
                }
            });
        }
    }
}
//Back button for Reset password page
function resetPasswordBackButton() {
    $(document).on('click', '.js-account-back', function () {
        const redirectLinkElement = $('.js-onboarding-button-redirect');
        if (redirectLinkElement.length > 0){
            window.location.href = redirectLinkElement.val();
        }
        return;
    });
}

/**
 * Tests if the dragList element exists on the page
 *
 * @returns {Boolean} result of test
 */
const shouldInit = () => document.querySelectorAll(resetPassPage).length > 0;


const crm23 = {
    init: function () {
        if (shouldInit()) {
            resetPasswordBackButton();
        }
        pushAnalyticsDataRegistrationForm();
        pushAnalyticsDataLoginForm();
        showPhoneNumberOnRegistrationForm();
        sendMeMyCardByEmail();
        closeResetPasswordToaster();

        if ($('.js-crm-set-password').length > 0) {
            login.init();
        }
    }
};

module.exports = crm23;
